import React, { HTMLAttributes } from 'react';

import styles from './Hint.module.scss';
import { getHintClasses } from './utils';
import { DesignSystemTypography } from '../../tokens/tokens';
import { Typography } from '../Typography/Typography';

type Props = HTMLAttributes<HTMLSpanElement> & {
  text: string;
  hotkey?: string;
};

export const Hint = ({
  text,
  hotkey,
  className,
  ...props
}: Props): JSX.Element => {
  return (
    <span
      data-design-system-hint
      className={getHintClasses({ className })}
      {...props}
    >
      <Typography
        variant={DesignSystemTypography.CAPTION_REGULAR}
        tag="span"
        className={styles.label}
      >
        {text}
      </Typography>
      {hotkey ? (
        <span className={styles.hotkey} data-design-system-hint-hotkey>
          <Typography
            variant={DesignSystemTypography.CAPTION_REGULAR}
            tag="span"
            className={styles.hotkey_separator}
          >
            •
          </Typography>
          <Typography
            variant={DesignSystemTypography.CAPTION_REGULAR}
            tag="span"
            className={styles.hotkey_value}
          >
            {hotkey}
          </Typography>
        </span>
      ) : null}
    </span>
  );
};

export type { Props as HintProps };
